module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset class="block">\n  <legend>Transaction List</legend>\n  <div class="search-hook" id="filter"></div>\n  <div id="table-hook"></div>\n  <div class="page-hook"></div>\n</fieldset>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment/templates/transaction/index.html
// module id = 342
// module chunks = 0